import { Schema, arrayOf } from 'normalizr';

export const post = new Schema('posts');
export const notification = new Schema('notifications');
export const onboardingOption = new Schema('onboardingOptions', {
  idAttribute: o => o.optionId,
});
export const thread = new Schema('threads', {
  idAttribute: u => u.threadId || u.id,
});
export const message = new Schema('messages');
export const user = new Schema('users', {
  idAttribute: u => u.userId || u.id,
});
export const group = new Schema('groups', {
  idAttribute: g => g.groupId || g.id,
});

post.define({
  response: post,
  responses: arrayOf(post),
  parent: post,
  superParent: post,
  author: user,
  group,
});
user.define({
  followers: arrayOf(user),
  groups: arrayOf(group),
});
notification.define({
  post,
  superParent: post,
});
thread.define({
  lastActiveUser: user,
  participants: arrayOf(user),
  group: group,
});
message.define({
  author: user,
  thread,
});



// WEBPACK FOOTER //
// ./~/virgo/src/normalizeSchema.js